import React, { useEffect, useState } from "react";
import { Offcanvas, Button } from "react-bootstrap";
import Common_Back_Btn from "../../common_components/common_back_btn/Common_Back_Btn";
import Success_Toster from "../../common_modal/success_toster/Success_Toster";
import { GetAllInstrument } from "../../../features/admin/quality_management/resource_requirement/equipment/Slice";
import { useDispatch } from "react-redux";

function Delete_offcanvas({
  show,
  handleClose,
  offcanvasHeading,
  massageText,
  handleDelete,
  fetchCustomers
 
}) {
  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch();

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
       dispatch(GetAllInstrument());
      const timer = setTimeout(() => {
        setSuccess(false);
        handleClose();
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [success]);

  return (
    <Offcanvas
      className="mobile_offcanvas confirmation_offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          {offcanvasHeading}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <div className="text_holder">
          <p>
            Are you sure you want to <span>delete</span> the {massageText}{" "}?
          </p>
        </div>

        <div className="permission_btn_holder">
          {success ? (
            <Success_Toster successText="Delete File Successfully!" />
          ) : (
            <>
              <Button
                type="button"
                className="permission_btn No_btn"
                onClick={handleClose}
              >
                No
              </Button>

              <Button
                type="button"
                className="permission_btn Yes_btn"
                onClick={async () => {
                  await handleDelete();
                  setSuccess(true);
                }}
              >
                Yes
              </Button>
            </>
          )}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Delete_offcanvas;
